import React from 'react';
import withData from '../../../../core/containers/withData';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';

class StartersVsBench extends React.Component {
  renderRows() {
    const { data } = this.props;

    if (!data || !data.length) {
      return null;
    }

    let rows = [];

    for (let i = 0; i <= 1; i++) {
      const row = data[i];
      rows.push(
        <tr key={ i }>
          <td>
            { row.started ?
              <strong>Starters</strong> :
              <strong className="text-muted">Bench</strong>
            }
          </td>
          <td>{ row.points.toFixed(1) }</td>
          <td>{ (row.points + data[1-i].points) ? (100 * row.points / (row.points + data[1-i].points)).toFixed(1) : '-' }</td>
          <td>{ row.of_rebounds.toFixed(1) }</td>
          <td>{ (row.of_rebounds + data[1-i].of_rebounds) ? (100 * row.of_rebounds / (row.of_rebounds + data[1-i].of_rebounds)).toFixed(1) : '-' }</td>
          <td>{ row.df_rebounds.toFixed(1) }</td>
          <td>{ (row.df_rebounds + data[1-i].df_rebounds) ? (100 * row.df_rebounds / (row.df_rebounds + data[1-i].df_rebounds)).toFixed(1) : '-' }</td>
          <td>{ row.assists.toFixed(1) }</td>
          <td>{ (row.assists + data[1-i].assists) ? (100 * row.assists / (row.assists + data[1-i].assists)).toFixed(1) : '-' }</td>
          <td>{ row.turnovers.toFixed(1) }</td>
          <td>{ (row.turnovers + data[1-i].turnovers) ? (100 * row.turnovers / (row.turnovers + data[1-i].turnovers)).toFixed(1) : '-' }</td>
          <td>{ row.turnovers ? (row.assists / row.turnovers).toFixed(1) : '-' }</td>
          <td>{ row.steals.toFixed(1) }</td>
          <td>{ (row.of_rebounds + data[1-i].steals) ? (100 * row.steals / (row.steals + data[1-i].steals)).toFixed(1) : '-' }</td>
        </tr>
      );
    }

    return rows;
  }

  render() {
    const { combined, isFetching } = this.props;

    return (
      <Box title={ `Starters vs Bench Stats (All Games${combined ? ', combined': ''})` }
           className="table-responsive">
        { isFetching && <Spinner /> }
        <table className="table table-bordered table-hover table-stats">
        <tbody>
          <tr>
            <th></th>
            <th>PTS</th>
            <th>PTS %</th>
            <th>OR</th>
            <th>OR %</th>
            <th>DR</th>
            <th>DR %</th>
            <th>AS</th>
            <th>AS %</th>
            <th>TO</th>
            <th>TO %</th>
            <th>AS/TO</th>
            <th>ST</th>
            <th>ST %</th>
          </tr>
          { this.renderRows() }
        </tbody>
        </table>
      </Box>
    );
  }
};

export default withData(StartersVsBench);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/StartersVsBench/StartersVsBench.js